import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROUTES } from '../config/constants';
import LoadingSpinner from '../components/feedback/LoadingSpinner';

/**
 * Guard de rutas. Tres niveles de protección:
 * - requireAuth: requiere sesión activa
 * - requireFamily: requiere que el usuario tenga familyId asignado
 *
 * Cualquier ruta que use este componente asume que AuthProvider está montado arriba.
 */
const ProtectedRoute = ({ children, requireAuth = true, requireFamily = true }) => {
  const { status, isAuthenticated, hasFamily } = useAuth();
  const location = useLocation();

  if (status === 'initializing') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <LoadingSpinner label="Verificando sesión..." />
      </div>
    );
  }

  if (requireAuth && !isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (requireFamily && isAuthenticated && !hasFamily) {
    return <Navigate to={ROUTES.ONBOARDING} replace />;
  }

  return children;
};

export default ProtectedRoute;